module.exports = __webpack_public_path__ + "img/s.232556a0.png";